import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import moment from 'moment'
import VueGtag from 'vue-gtag'

import './plugins/transitions'
import './plugins/session'
import http from './plugins/http'
import './plugins/lodash'
import './plugins/helpers'
import './plugins/mixins'
import './plugins/components'

import './assets/material_icons.css'
import './assets/material_outline.css'
import './assets/linearicons.css'
import './assets/flavors/fonts.css'
import 'swiper/swiper-bundle.css'
import './assets/application.scss'
import './assets/icons.css'

import './directives/input-filter'
import './directives/validateRG'

import App from './App'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Hotjar from 'vue-hotjar'
moment.locale('pt-BR')

new Vue({
  vuetify,
  router,
  store,
  mounted: function () {
    Vue.use(VueGtag, {
      config: { id: process.env.VUE_APP_ANALYTICS_GA }
    })
    this.getHotjar()
  },
  methods: {
    getHotjar () {
      http.get('/hotjar').then(r => {
        Vue.use(Hotjar, {
          id: r.data.hjid.toString(), // Hotjar Site ID
          snippetVersion: r.data.hjsv
        })
      })
    }
  },
  render: h => h(App)
}).$mount('#app')
